export class PipeCleanoutUtility {
  static ftDivider = 12

  constructor(inches) {
    this.inches = inches
  }

  get ft() {
    return this.inches / PipeCleanoutUtility.ftDivider
  }
}

export default class PipeCleanout {
  static TYPE = {
    _M: {
      identifier:null,
      tConnections: 3,
      imgType: 'PIPE_CLEANOUT',
      od: new PipeCleanoutUtility(30),
      width: new PipeCleanoutUtility(30),
      length: new PipeCleanoutUtility(30),
      description: '36" X 90" Demo',
    },
    _3698AN: {
      tConnections: 3,
      imgType: 'PIPE_CLEANOUT',
      od: new PipeCleanoutUtility(30),
      width: new PipeCleanoutUtility(52.3),
      length: new PipeCleanoutUtility(52.3),
      description: '36" X 90" Demo',
    },
  }
}



// WEBPACK FOOTER //
// ./src/lib/Pipes/PipeAccessories/pipe-cleanout.js